import { LoaderActions } from '@store/loaders'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { PROJECT_HISTORY_INIT } from '@store/reducers/manager/middleware/history/types'
import { initProjectActionsSaga } from '@store/reducers/manager/sagas/initProjectActionsSaga'
import { CanvasActionTypes } from '@storeOld/reducers/canvas/canvas'
import { call, put, select } from 'redux-saga/effects'

export function* createProjectBoilerplateSaga() {
  yield put(LoaderActions.set('project'))

  try {
    yield call(initProjectActionsSaga)

    // @ts-expect-error
    const tabId = yield select(migrationProjectSelector.getActiveOrFirstTabId)

    yield put({
      type: CanvasActionTypes.SET_ACTIVE_TAB,
      payload: { id: tabId },
    })

    yield put({
      type: PROJECT_HISTORY_INIT,
    })

    yield put(LoaderActions.unset('project'))
  } catch (error) {
    console.error('Error creating project boilerplate:', error)
  } finally {
    yield put(LoaderActions.unset('project'))
  }
}
